import { FC, SVGProps } from 'react';

export const DownIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 25.5C15.7854 25.5 15.5811 25.4081 15.4387 25.2475L7.43875 16.2218C7.164 15.9119 7.19255 15.4378 7.50253 15.1631C7.8125 14.8883 8.28652 14.9169 8.56127 15.2269L15.0752 22.5759C15.1362 22.6448 15.25 22.6016 15.25 22.5096V6.75C15.25 6.33579 15.5858 6 16 6C16.4142 6 16.75 6.33579 16.75 6.75V22.5096C16.75 22.6016 16.8638 22.6448 16.9248 22.5759L23.4387 15.2269C23.7135 14.9169 24.1875 14.8883 24.4975 15.1631C24.8075 15.4378 24.836 15.9119 24.5613 16.2218L16.5613 25.2475C16.4189 25.4081 16.2146 25.5 16 25.5Z"
			fill="currentColor"
		/>
	</svg>
);
